import React, { useEffect, useState } from "react";
import axios from '../../services/axios';
import Button from "../../components/Button/Button";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';  // updated import
import { refreshToken, logout } from "../../hooks/useAuth";
import { HomeButton } from "../../components/homeButton/homeButton";
import { getStorage } from '../../hooks/useAuth';
import { API_CONFIG } from "../../apis/api-config";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';


import "./Profile.css";


function Profile() {
    const navigate = useNavigate();  // updated hook
    const [languages, setLanguages] = useState([]);
    const token = getStorage().getItem('access_token');
    const { register, handleSubmit, reset } = useForm();
    const [userImage, setUserImage] = useState('');
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.currentUser);

    axios.defaults.headers.common.Accept = 'application/json';
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.defaults.timeout = API_CONFIG.TIMEOUT;

    const handleLogout = () => {
        logout();
    }

    const fetchLanguages = async () => {
        try {
            const response = await axios.get(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SYSTEM_LANGUAGE}`);
            setLanguages(response.data);
        } catch (error) {
            if (error.response?.status === 401) {
                await refreshToken();
                fetchLanguages(); // Retry after refresh
            }
        }
    };

    useEffect(() => {
        fetchLanguages();
    }, []);

    useEffect(() => {
        if (currentUser) {
            setUserImage(currentUser.profileImageUrl || '');
            reset({
                firstName: currentUser.firstName,
                lastName: currentUser.lastName,
                language: currentUser.language,
            });
        }
    }, [currentUser]);

    const onSubmit = async (data) => {
        if (!currentUser) return;

        const userData = {
            firstName: data.firstName || currentUser.firstName,
            lastName: data.lastName || currentUser.lastName,
            language: data.language || currentUser.language,
        };

        try {
            const response = await axios.put(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CURRENT_USER}`,
                userData,
                {
                    timeout: API_CONFIG.TIMEOUT,
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            dispatch({
                type: "currentUser/updateCurrentUser",
                payload: response.data
            });

        } catch (err) {
            console.error(err);
        }
    };


    const deleteUserImage = async () => {
        try {
            const response = await axios.delete(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USER_CURRENT_IMAGE}`, {
                timeout: API_CONFIG.TIMEOUT
            }); 
            dispatch({
                type: "currentUser/updateCurrentUser",
                payload: response.data
            });
            setUserImage('');
            reset({ ...currentUser, profileImageUrl: '' });
        } catch (err) {
            console.error(err);
        }
    };

    const changeUserImage = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.put(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USER_CURRENT_IMAGE}`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            dispatch({
                type: "currentUser/updateCurrentUserImage",
                payload: response.data.profileImageUrl
            });

            setUserImage(response.data.profileImageUrl);
        } catch (err) {
            console.error(err);
        }
    };

    let image = (
        <div className="upload-file__wrapper">
            <img alt="add" src="/img/plus.svg" className="plus-icon" />
            <input
                type="file"
                name="file"
                onChange={(e) => { if (e.target.files[0]) changeUserImage(e.target.files[0]); }}
                className="el-upload__input"
            />
        </div>
    );

    if (userImage !== '') {
        image = (
            <div className="uploaded-image-wrapper">
                <img alt="profile-image" className="upload-file__wrapper" src={userImage} />
                <div>
                    <div className="delete-image" onClick={deleteUserImage} role="button" tabIndex={0}>
                        <img className="dustbin-icon" src="/img/dustbin.svg" alt="delete" />
                        <div>Delete image</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="profile-container">
            <div className="home-button-container">
                <HomeButton />
                <h3 className="profile-title">{t('accountSettings:profile', 'Profile')}</h3>
            </div>

            <div className="profile-preview">
                <div className="profile-preview-image-wrapper">
                    <div className="input-wrapper input-bottom">
                        {image}
                    </div>
                </div>
                <div className="profile-preview-info">
                    <h4>{currentUser ? `${currentUser.firstName} ${currentUser.lastName}` : 'User Name'}</h4>
                    <p>{currentUser ? currentUser.email : 'view your email'}</p>
                </div>
            </div>

            <form className="form-wrapper" onSubmit={handleSubmit(onSubmit)}>
                <div className="data-input-wrapper">
                    <div className="input-wrapper">
                        <label htmlFor="firstName" className="form-profile-label">{t('admin:users.firstName', 'First Name')}</label>
                        <input type="text" id="firstName" {...register('firstName')} />
                    </div>

                    <div className="input-wrapper input-bottom">
                        <label htmlFor="lastName" className="form-profile-label">{t('admin:users.lastName', 'Last Name')}</label>
                        <input type="text" id="lastName" {...register('lastName')} />
                    </div>

                    

                    <div className="input-wrapper input-bottom">
                        <label htmlFor="language" className="form-profile-label">{t('accountSettings:selectLanguage', 'Select language')}</label>
                        <select id="language" className="form-control-select" {...register("language")}>
                            {languages.map((e) => (
                                <option key={e.id} value={e.id}>
                                    {e.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="button-wrapper">
                        <Button primary="true" label={t('save', 'Save')} type="submit" />
                    </div>

                    <div className="logout-button">
                        <div className="mt-2">
                            <Button primary={false} label={
                                <>
                                    {t('layout:navbar.logout', 'Logout')}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round"
                                        style={{ marginLeft: '6px', verticalAlign: 'middle' }}
                                    >
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                        <polyline points="16 17 21 12 16 7" />
                                        <line x1="21" y1="12" x2="9" y2="12" />
                                    </svg>
                                </>
                            }
                                onClick={handleLogout} />
                        </div>
                    </div>

                </div>
            </form>
            
            
        </div>
    )
}

export default Profile;
